module.exports = __webpack_public_path__ + "img/garchenLogo.c14a95a9.png";